import { render, staticRenderFns } from "./bk-tab.vue?vue&type=template&id=1e2a5dfb&scoped=true&"
import script from "./bk-tab.vue?vue&type=script&lang=js&"
export * from "./bk-tab.vue?vue&type=script&lang=js&"
import style0 from "./bk-tab.vue?vue&type=style&index=0&id=1e2a5dfb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2a5dfb",
  null
  
)

export default component.exports